import React, { useEffect, useState } from "react";

import Menu from "./Menu";
import { useOktaAuth } from "@okta/okta-react";
import { ADMIN_MENU, MENU_LINKS, USER_PROFILE , SUPER_ADMIN_MENU} from "../../config";
import { Container, Content, Item, InitialsAvatar } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { ClickAwayListener, Popper } from "@mui/material";
import { borderRadius } from "@mui/system";
import { useHistory } from "react-router-dom";
import { setSelectedClient } from "redux/actions/clientActions";

const HOST = window.location.host;
const CALLBACK_PROTOCOL = process.env.REACT_APP_CALLBACK_PROTOCOL || "https";
const REDIRECT_URI = `${CALLBACK_PROTOCOL}://${HOST}/logout`;

const ProfileMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { oktaAuth } = useOktaAuth();
  const userInfo = useSelector((state) => state.currentUser.details);
  const { isAdmin, userFirstName, userLastName } = userInfo ?? {};
  useEffect(() => {}, [anchorEl]);
  const dispatch = useDispatch();

  const model = {
    initials:
      userFirstName && userLastName
        ? `${userFirstName[0]}${userLastName[0]}`.toUpperCase()
        : "U",
    userName: `${userFirstName ?? 'User'} ${userLastName ?? ''}`,
  };

  let menuLinks = MENU_LINKS;
  const history = useHistory();
  const selectedClientId = useSelector(
    (state) => state.clients.selectedClientId
  );
  const [isAccountLead , setIsAccountLead] = useState(false);
  const menuItems = isAdmin ? [USER_PROFILE , ADMIN_MENU, SUPER_ADMIN_MENU, ...menuLinks] : 
   isAccountLead ? [USER_PROFILE, ADMIN_MENU, ...menuLinks] : [USER_PROFILE, ...menuLinks];
  /* End */
  const onLogout = () => {
    dispatch(setSelectedClient(null));
    history.push("/Logout");
    oktaAuth.signOut({ postLogoutRedirectUri: REDIRECT_URI });
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (userInfo && userInfo.userClients && selectedClientId) {
      const accountLeadRole = userInfo.userClients.find(cl => (cl.roleName.toLowerCase().includes("account lead") || cl.roleName.toLowerCase().includes("tme al")) && cl.clientId === selectedClientId);
      setIsAccountLead(!!accountLeadRole);
    }
  }, [userInfo, selectedClientId]);

  return (
    <>
      <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
        <div>
          <div
            style={{
              marginRight: "16px",
              display: "flex",
              height: "100%",
              alignItems: "center",
            }}
            onClick={(e) => !anchorEl ? setAnchorEl(e.currentTarget) : closeMenu()}
          >
            <InitialsAvatar style={{ marginRight: 0, cursor: "pointer" }}>
              {model.initials}
            </InitialsAvatar>
          </div>
          <Popper
            sx={{ zIndex: 9999 }}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
          >
            <div
              style={{
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                textAlign: "left",
                whiteSpace: "nowrap",
                borderRadius: "8px",
                fontSize: "14px",
                zIndex: 2000,
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                minWidth: "220px",
              }}
            >
              <Menu data={menuItems} onLogout={onLogout} closeMenu={closeMenu} />
            </div>
          </Popper>
        </div>
      </ClickAwayListener>
    </>
  );
};

export default ProfileMenu;
